import { Button } from "react-bootstrap";
import CustomModal from "./../customModal/CustomModal";
import markCompleteModalImage from "../../assets/images/mark-complete-modal-image.svg";
import React from "react";

interface ConfirmationModalProps {
  showModal: boolean;
  toggleModal: () => void;
  confirmAction: () => void;
  actionLabel: string;
  modelName: string;
  recordName?: string;
  image?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  showModal,
  toggleModal,
  confirmAction,
  actionLabel,
  modelName,
  recordName,
  image = markCompleteModalImage,
}) => {
  if (!showModal) return null;

  return (
    <CustomModal
      title=""
      content={
        <div className="delete-confirm-modal-wrapper">
          <div className="modal--content--wrapper">
            <img src={image} alt="" />
            <h5>
              Are you sure you want to <br />
              {actionLabel} this {modelName}{" "}
              <span className="action-item-name" title={recordName || ""}>
                '{recordName || ""}'
              </span>
              ?
            </h5>
          </div>
          <div className="modal--action--btn--wrapper">
            <Button
              type="button"
              variant="outline-primary"
              onClick={toggleModal}
            >
              Cancel
            </Button>
            <Button type="button" variant="primary" onClick={confirmAction}>
              {actionLabel}
            </Button>
          </div>
        </div>
      }
      onClose={toggleModal}
    />
  );
};
